/**
 * TestReminderBadge — "Due Soon" amber pill on kit cards (bonus C).
 */
import type { ParameterKey, TestLogEntry } from '@reefapp/shared';

export interface TestReminderBadgeProps {
  parameterKey: ParameterKey;
  logs: ReadonlyArray<TestLogEntry>;
  enabled: boolean;
  thresholdDays?: number;
}

export function TestReminderBadge({
  parameterKey,
  logs,
  enabled,
  thresholdDays = 7,
}: TestReminderBadgeProps) {
  if (!enabled) return null;

  const now = Date.now();
  const thresholdMs = thresholdDays * 24 * 60 * 60 * 1000;

  const latest = logs
    .filter(
      (l) =>
        l.parameterKey === parameterKey && typeof l.result === 'number',
    )
    .sort(
      (a, b) =>
        new Date(b.date).getTime() - new Date(a.date).getTime(),
    )[0];

  if (!latest) return null;

  const age = now - new Date(latest.date).getTime();
  if (age <= thresholdMs) return null;

  return (
    <span className="ml-2 inline-flex items-center rounded-full bg-amber-500/20 px-2 py-0.5 text-xs font-semibold text-amber-400">
      Due Soon
    </span>
  );
}
